import { useEffect, useRef, useState } from "react";
import Work, { Photography } from "../work/work";
import styles from "./scroll.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Header from "../header/header";
import Scenery from "../scenery/scenery";
import Navigation, { NavigationHandle } from "../navigation/navigation";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const workPosterData: Photography[] = [
  {
    src:
      "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-1-1.jpg",
  },
  {
    src:
      "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-1.jpg",
  },
  {
    ratio: 0.6667,
    src:
      "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-3-1.jpg",
  },
  {
    ratio: 0.75,
    src:
      "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-6.jpg",
  },
];
const photographyData: Photography[][] = [
  [
    {
      data: [
        "SONY ILCE-7RM4",
        "SIGMA 14-24mm F2.8 DG DN | Art",
        "智云五倍 V60·2800K 30W(50%)",
      ],
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-1-2.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-1-2.jpg",
    },
    {
      data: [
        "SONY ILCE-7RM4",
        "SIGMA 14-24mm F2.8 DG DN | Art",
        "智云五倍 V60·2800K 30W(50%)",
      ],
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-1-3.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-1-3.jpg",
    },
    {
      data: [
        "SONY ILCE-7RM4",
        "SIGMA 14-24mm F2.8 DG DN | Art",
        "智云五倍 V60·2800K 30W(50%)",
      ],
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-1-4.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-1-4.jpg",
    },
    {
      data: [
        "FUJIFILM GFX 50S",
        "ZEISS Touit 2.8/50M",
        "智云五倍V60·5500K 3W(5%)",
      ],
      ratio: 0.75,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-1-5.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-1-5.jpg",
    },
    {
      data: [
        "FUJIFILM X-Pro 2",
        "ZEISS Touit 2.8/50M",
        "智云五倍V60·5500K 3W(5%)",
      ],
      ratio: 1.6,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-1-6.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-1-6.jpg",
    },
    {
      data: [
        "FUJIFILM GFX 50S",
        "ZEISS Touit 2.8/50M",
        "智云五倍V60·5500K 3W(5%)",
      ],
      ratio: 0.75,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-1-7.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-1-7.jpg",
    },
  ],
  [
    {
      data: [
        "Canon EOS 5D Mark IV",
        "SIGMA 24-70mm F2.8 DG OS HSM | Art",
        "智云五倍 V60·5500K 42W(70%)",
      ],
      ratio: 0.6667,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-2.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-2-2.jpg",
    },
    {
      data: [
        "Canon EOS 5D Mark IV",
        "SIGMA 24-70mm F2.8 DG OS HSM | Art",
        "智云五倍 V60·5500K 42W(70%)",
      ],
      ratio: 0.6667,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-3.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-2-3.jpg",
    },
    {
      data: [
        "Canon EOS 5D Mark IV",
        "SIGMA 24-70mm F2.8 DG OS HSM | Art",
        "智云五倍 V60·5500K 60W(100%)",
      ],
      ratio: 0.6667,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-4.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-2-4.jpg",
    },
    {
      data: [
        "Canon EOS 5D Mark IV",
        "SIGMA 24-70mm F2.8 DG OS HSM | Art",
        "智云五倍 V60·5500K 24W(40%)",
      ],
      ratio: 1.5,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-5.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-2-5.jpg",
    },
  ],
  [
    {
      data: [
        "NIKON Z 9",
        "NIKKOR Z 105mm f/2.8 VR S",
        "智云五倍V60·4000K 100W(MAX)",
      ],
      ratio: 0.6667,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-3-2.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-3-2.jpg",
      gagsSrc:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-3-8.jpg",
    },
    {
      data: [
        "NIKON Z 9",
        "NIKKOR Z 105mm f/2.8 VR S",
        "智云五倍 V60·5500K 100W(MAX)",
      ],
      ratio: 0.6667,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-3-3.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-3-3.jpg",

      gagsSrc:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-3-9.jpg",
    },
    {
      data: [
        "NIKON Z 9",
        "NIKKOR Z 105mm f/2.8 VR S",
        "智云五倍 V60·5500K 100W(MAX)",
      ],
      ratio: 0.6667,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-3-4.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-3-4.jpg",
    },
    {
      data: [
        "NIKON Z 9",
        "NIKKOR Z 105mm f/2.8 VR S",
        "智云五倍V60·3700K 100W(MAX)",
      ],
      ratio: 0.6667,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-3-5.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-3-5.jpg",
      gagsSrc:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-3-10.jpg",
    },
    {
      data: [
        "NIKON Z 9",
        "NIKKOR Z 105mm f/2.8 VR S",
        "智云五倍V60·3700K 100W(MAX)",
      ],
      ratio: 0.6667,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-3-6.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-3-6.jpg",
    },
  ],

  [
    {
      data: [
        "PENTAX 645Z",
        "smc PENTAX-FA645 75mmF2.8",
        "智云五倍 V60·3300K 30W(50%)",
      ],
      ratio: 1.333,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-7.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-2-7.jpg",
    },
    {
      data: [
        "PENTAX 645Z",
        "smc PENTAX-FA645 75mmF2.8",
        "智云五倍 V60·4000K 30W(50%)",
      ],
      ratio: 1.333,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-8.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-2-8.jpg",
    },
    {
      data: [
        "PENTAX 645Z",
        "smc PENTAX-FA645 75mmF2.8",
        "智云五倍 V60·3300K 30W(50%)",
      ],
      ratio: 1.333,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-9.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-2-9.jpg",
    },
    {
      data: [
        "PENTAX 645Z",
        "smc PENTAX-FA645 75mmF2.8",
        "智云五倍 V60·3300K 30W(50%)",
      ],
      ratio: 0.75,
      src:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-photo-2-10.jpg",
      preview:
        "http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-preview-2-10.jpg",
    },
  ],
];

function Scroll() {
  const ctn = useRef<HTMLDivElement>(null);
  const [containerAnimation, setContainerAnimation] = useState<
    gsap.core.Animation[]
  >();

  const navRef = useRef<NavigationHandle>(null);

  const worksLength = photographyData.length;

  useEffect(() => {
    console.log("重新渲染了");
    const ctx = gsap.context(() => {
      const workCtns = document.querySelectorAll(
        ".shadow-v60-work-ctn"
      ) as NodeListOf<HTMLElement>;
      const workContents = document.querySelectorAll(
        ".shadow-v60-work-content"
      ) as NodeListOf<HTMLElement>;

      const header = document.querySelector(
        ".shadow-v60-header"
      ) as HTMLElement;

      const workTimelines: gsap.core.Animation[] = [];

      let workTitleSize = 0;

      let oneScreen = 0;
      let workCtnSize = 0;
      let workCtnScrollDistance = 0;
      let workCtnScrollDistanceAccumulate = 0;
      const getWorkContentScrollDistance = (workContentSize: number) => {
        return workContentSize - getWorkCtnSize();
      };

      const getWorkHeaderBoxScrollDistance = (
        workHeaderBoxSize: number,
        index: number
      ) => {
        return workHeaderBoxSize - workTitleSize;
      };

      const getInfoBoxScrollDistance = (infoBoxSize: number) => {
        return infoBoxSize - (getWindowSize() - workTitleSize * worksLength);
      };

      const getWindowSize = () => {
        return window.innerWidth;
      };

      const getWorkCtnSize = () => {
        return getWindowSize() - workTitleSize * (worksLength - 1);
      };

      const getWorkCtnScrollDistance = () => {
        return getWindowSize() - workTitleSize * worksLength;
      };

      ScrollTrigger.matchMedia({
        "(min-width: 1024px)": function () {
          workTitleSize = 100;
          oneScreen = window.innerWidth;
          workCtnSize = getWindowSize() - workTitleSize * (worksLength - 1);
          workCtnScrollDistance = getWindowSize() - workTitleSize * worksLength;
          const tl = gsap.timeline({
            defaults: {
              ease: "none",
            },
            scrollTrigger: {
              trigger: ctn.current,
              pin: true,
              scrub: 1.4,
              // end: () => {
              //   let end = 0;
              //   workContents.forEach((item) => {
              //     end += getWorkCtnScrollDistance();
              //     end += getWorkContentScrollDistance(item.offsetWidth);
              //   });

              //   return end;
              // },

              end: "2400%",

              onUpdate: (self) => {
                navRef.current?.updateProgress(`${self.progress * 100}%`);
              },

              onRefresh: () => {
                navRef.current?.updateGsapLabels({
                  photography: getPhotographysScrollPercent(
                    tl.labels,
                    tl.totalDuration()
                  ),
                  ctn: getCtnsScrollPercent(tl.labels, tl.totalDuration()),
                });
              },
              invalidateOnRefresh: true,
              fastScrollEnd: true,
              preventOverlaps: true,
            },
          });

          tl.addLabel("start", 0);

          let photographyIndex = 0;

          workContents.forEach((item, index, array) => {
            // const workScroll = gsap.timeline

            const workTimeline = gsap.timeline();

            workTimeline.fromTo(
              workCtns[index],
              {
                x: () => (array.length - index) * -workTitleSize,
              },
              {
                x: () => {
                  return -getWindowSize() + index * workTitleSize;
                },
                ease: "none",
                duration: 1,
              }
            );

            tl.addLabel(`ctn-scroll-${index}`, `+=${1}`);

            workCtnScrollDistanceAccumulate += getWorkCtnScrollDistance();

            const workBoxs = item.querySelectorAll(
              ":scope > div"
            ) as NodeListOf<HTMLElement>;
            const photographyBox = item.querySelectorAll(
              ".shadow-v60-photography-box"
            ) as NodeListOf<HTMLElement>;

            // header 部分滚动
            workTimeline.to(workBoxs, {
              x: () =>
                `-=${getWorkHeaderBoxScrollDistance(
                  workBoxs[0].offsetWidth,
                  index
                )}`,
              ease: "none",
              duration: () =>
                getWorkHeaderBoxScrollDistance(workBoxs[0].offsetWidth, index) /
                getWorkCtnScrollDistance(),
            });

            tl.addLabel(
              `header-scroll-${index}`,
              `+=${
                1 +
                getWorkHeaderBoxScrollDistance(workBoxs[0].offsetWidth, index) /
                  getWorkCtnScrollDistance()
              }`
            );

            console.log(tl.labels[`header-scroll-${index}`]);

            // 作品部分滚动

            photographyBox.forEach((item, j, array) => {
              if (j === 0) {
                workTimeline.to(workBoxs, {
                  x: "-=160",
                  ease: "none",
                  duration: () => 160 / getWorkCtnScrollDistance(),
                });

                tl.addLabel(
                  `photography-scroll-${photographyIndex}`,
                  `${
                    tl.labels[`header-scroll-${index}`] +
                    160 / getWorkCtnScrollDistance()
                  }`
                );

                console.log(
                  tl.labels[`photography-scroll-${photographyIndex}`]
                );

                photographyIndex++;
              } else {
                workTimeline.to(workBoxs, {
                  x: () => `-=${array[j - 1].offsetWidth + 160}`,
                  ease: "none",
                  duration: () =>
                    (array[j - 1].offsetWidth + 160) /
                    getWorkCtnScrollDistance(),
                });

                tl.addLabel(
                  `photography-scroll-${photographyIndex}`,
                  `${
                    tl.labels[`photography-scroll-${photographyIndex - 1}`] +
                    (array[j - 1].offsetWidth + 160) /
                      getWorkCtnScrollDistance()
                  }`
                );
                photographyIndex++;
              }
            });

            // 摄影师和评价部分滚动
            workTimeline.to(workBoxs, {
              x: () =>
                `-=${getInfoBoxScrollDistance(
                  photographyBox[photographyBox.length - 1].offsetWidth +
                    workBoxs[workBoxs.length - 1].offsetWidth +
                    160
                )}`,
              ease: "none",
              duration: () =>
                getInfoBoxScrollDistance(
                  photographyBox[photographyBox.length - 1].offsetWidth +
                    workBoxs[workBoxs.length - 1].offsetWidth +
                    160
                ) / getWorkCtnScrollDistance(),
            });

            tl.addLabel(
              `info-scroll-${index}`,
              `${
                tl.labels[`photography-scroll-${photographyIndex - 1}`] +
                getInfoBoxScrollDistance(
                  photographyBox[photographyBox.length - 1].offsetWidth +
                    workBoxs[workBoxs.length - 1].offsetWidth +
                    160
                ) /
                  getWorkCtnScrollDistance()
              }`
            );

            console.log("foreach 循环结束");

            // workTimeline.to(item.querySelectorAll(":scope > div"), {
            //   x: () => -getWorkContentScrollDistance(item.offsetWidth),
            //   ease: "none",
            //   duration: () =>
            //     getWorkContentScrollDistance(item.offsetWidth) /
            //     getWorkCtnScrollDistance(),
            // });

            // tl.addLabel(
            //   `content-scroll-${index}`,
            //   `+=${
            //     getWorkContentScrollDistance(item.offsetWidth) /
            //     getWorkCtnScrollDistance()
            //   }`
            // );

            if (index !== 0) {
              workTimeline.to(
                array[index - 1],
                {
                  x: () => -getWorkCtnScrollDistance(),
                  ease: "none",
                  duration: 1,
                },
                0
              );
            }

            tl.add(workTimeline);

            workTimelines.push(workTimeline);
          });

          tl.to(
            header,
            {
              x: () => -getWorkCtnScrollDistance(),
              duration: 1,
              ease: "none",
            },
            0
          );

          tl.addLabel("end");
        },
      });

      setContainerAnimation(workTimelines);
    }, ctn);

    return () => ctx.revert();
  }, []);

  // useEffect(() => {
  //   const workTitle = document.querySelectorAll(
  //     ".shadow-v60-work-title"
  //   ) as NodeListOf<HTMLElement>;
  //   if(containerAnimation) {
  //     workTitle.forEach((item, index) => {
  //       item.addEventListener("click", (e) => {
  //         e.preventDefault();
  //         // toWork(index);
  //         console.log(containerAnimation[index].duration());
  //         // tl.seek(`ctn-scroll-${index}`)
  //       });
  //     });
  //   }

  // }, [containerAnimation]);

  useEffect(() => {
    ScrollTrigger.refresh();
  }, [containerAnimation]);

  const getPhotographysScrollPercent = (
    gsapLabels: { [propName: string]: number },
    totalDuration: number
  ) => {
    const photographyScrollPercent: string[] = [];
    for (const labes in gsapLabels) {
      if (labes.includes("photography-scroll")) {
        photographyScrollPercent.push(
          `${(gsapLabels[labes] / totalDuration) * 100}%`
        );
      }
    }
    return photographyScrollPercent;
  };

  const getCtnsScrollPercent = (
    gsapLabels: { [propName: string]: number },
    totalDuration: number
  ) => {
    const CtnsScrollPercent: string[] = [];
    for (const labes in gsapLabels) {
      if (labes.includes("ctn-scroll")) {
        CtnsScrollPercent.push(`${(gsapLabels[labes] / totalDuration) * 100}%`);
      }
    }
    return CtnsScrollPercent;
  };
  return (
    <div
      className={styles.ctn}
      ref={ctn}
      style={{ "--work-length": worksLength } as React.CSSProperties}
    >
      <Header
        containerAnimation={containerAnimation?.[0]}
        worksLength={worksLength}
      />
      <div className={styles.workBox}>
        <Work
          worksLength={worksLength}
          category="风光摄影"
          header="{{捕“光”捉影}}{{{照度满分}}}{{让创作变简单}}{{灵感无界实力强悍}}"
          common="在没有光影的时候，_
          我需要自己来创造光源，_
          来让平淡无奇的影像富有质感。_
          V60，就是那束光。"
          author={{
            name: "王宁",
            title: "《中国国家地理》 图片编辑/摄影师_智云合作摄影师",
            introduction:
              "王宁于俄罗斯完成学业后，便加入《中国国家地理》，担任摄影师和图片编辑。他对摄影有着纯粹的热爱，足迹遍布南北两极、美国、北欧、东南亚等世界各地，从极地冰川到繁华城市，从野生动物到人物肖像，他用镜头捕捉世界各地的绮丽景象，创造出他眼中独一无二的世界。他的风格丰富多样，无论是分享与拍摄影像作品，均展现出精湛的摄影技巧和深厚的艺术造诣，同时富有情感与故事性。王宁的作品像是世界的缩影，不仅让人看到全球各地的秀美风光及独特地理环境孕育的多元风土人情，也将他的热情与创新精神融入其中。",
          }}
          index={0}
          poster={workPosterData[0]}
          photographys={photographyData[0]}
          containerAnimation={containerAnimation?.[0]}
        />
        <Work
          worksLength={worksLength}
          category="人像摄影"
          header="{{{柔光加倍}}}{{创意无限}}{{镜头记录故事}}{{同样记录}}{{你的美}}"
          common="V60扎实的做工与科技感外形，_
          兼顾高功率输出与便携性，_
          为每一次拍摄保驾护航。"
          author={{
            name: "王卿",
            title: "商业摄影师_智云合作摄影师",
            introduction:
              "王卿毕业于福州大学，作品涵盖商业广告、人物肖像、自然风光等多个领域，是“90后”摄影师中接触摄影较早且具有个人风格的摄影师。作为知名卫视的特约摄影师，与众多的知名演员、艺人保持合作。其中，他拍摄的情绪人像作品备受赞誉，色彩与质感带有明显的个人风格。除了商业拍摄，他同时非常热衷于摄影公益事业，他与特殊教育机构合作，长期为听障学生带来专属摄影课程，为他们的人生提供另一种可能性。他的拍摄足迹遍布世界各地，从约旦的瓦迪伦沙漠到东京的街头巷尾，他的旅行拍摄作品往往令人过目难忘。不仅展现了他敏锐的观察力和艺术感，也让观众仿佛置身于现场，在那一刻与摄影师共享摄影瞬间的魅力。",
          }}
          index={1}
          poster={workPosterData[1]}
          photographys={photographyData[1]}
          containerAnimation={containerAnimation?.[1]}
        />
        <Work
          worksLength={worksLength}
          category="静物摄影"
          header="{{质感纷呈}}{{{还原真实色彩}}}{{轻巧持控}}{{细节尽显其中}}"
          index={2}
          common="V60超频大功率与工业风_
          精巧外观的结合，_
          让光影创作随心所欲。"
          author={{
            name: "成诚",
            title: "商业摄影师/导演_智云合作摄影师",
            introduction:
              "无论是在静物、微距、人像、人文、旅行等各个领域，成诚都能以其精湛的技艺和敏锐的视角，呈现出细腻、真实的画面。作为多个知名手机品牌的官方摄影师，成诚为国产手机品牌多次拍摄官方手机样张，从精致的细节表现出产品的特性与张力。此外，也曾为音乐艺人拍摄MV和短片，他擅长运用镜头捕捉情感和故事的瞬间，彰显人物个性。他的作品不仅具备高水准，更注入了丰富的人文情感和艺术内涵。无论是商业摄影或是视频拍摄，成诚都以其卓越的摄影技巧和独特的视角，收获众多赞誉。不仅带来美学享受，也让镜头下的角色充分展现个性与价值。",
          }}
          poster={workPosterData[2]}
          photographys={photographyData[2]}
          containerAnimation={containerAnimation?.[2]}
        />
        <Work
          worksLength={worksLength}
          category="人像摄影"
          header="{{颜值高光}}{{{专业塑光}}}{{瞬间成永恒}}{{打造独特光影记忆}}"
          common="颜值与实力并存，_
          灯棒真正意义上成为_
          创作者生产力工具的开端之作。"
          author={{
            name: "周润",
            title: "人像摄影师_智云合作摄影师",
            introduction:
              "自幼学习音乐，07年于上海音乐学院毕业后却没有从事与音乐有关的工作， 而是成立了自己的摄影工作室。 09年开始接触孕妇人像创作，短时间内就成为业内知名摄影师。 他擅长捕捉人物微妙变化着的面部神情，并配合以细致的光线控制，他镜头下的准妈妈们无不散发着特殊的迷人魅力。 除孕妇人像以外，他还与上海民族乐团、上海话剧中心、上海京剧院等文艺演出团体保持着亲密的合作关系，为活跃在上海的许多艺术家们拍摄宣传照。",
          }}
          index={3}
          poster={workPosterData[3]}
          photographys={photographyData[3]}
          containerAnimation={containerAnimation?.[3]}
        />
      </div>

      <Navigation
        author={["王宁", "王卿", "成诚", "周润"]}
        category={["风光摄影", "人像摄影", "静物摄影", "人像摄影"]}
        containerAnimation={containerAnimation?.[0]}
        ref={navRef}
        photographyData={[
          ...photographyData[0],
          ...photographyData[1],
          ...photographyData[2],
          ...photographyData[3],
        ]}
      />
    </div>
  );
}

export default Scroll;
